import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiResult, ApiBillingInfo } from 'Types'

const endpoint = `${apiUrl.stable}/dadosFaturamento`

/** Returns the company's billing information of the authenticated user */
export const getBillingData = (): ApiResult<ApiBillingInfo & string> => {
  const url = `${endpoint}/obtem`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

/** Update the company's billing information of the authenticated user */
export const addBillingData = (data: ApiBillingEdit) => {
  const url = `${endpoint}/cadastra`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

/** Update the company's billing information of the authenticated user */
export const updateBillingData = (data: ApiBillingEdit) => {
  const url = `${endpoint}/atualiza`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

export default {
  getBillingData,
  addBillingData,
  updateBillingData,
}
